import { useState, useEffect, useContext } from "react";
import { AirCoolerContext } from "../context/AirCoolerContext";
import "./AirCoolerFaceplate.css";
import graphImg from "../assets/graph.jpg";

function AirCoolerFaceplate({
  tag,
  close,
  defaultPosition = { x: 300, y: 120 },
  baseRPM = 1900
}) {
  // =========================
  // HOOKS
  // =========================
  const [position, setPosition] = useState(defaultPosition);
  const [dragging, setDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  const ctx = useContext(AirCoolerContext);

  const coolerData = ctx?.coolerData;
  const updateCooler = ctx?.updateCooler;

  const data = coolerData?.[tag] ?? {
    speed: 0,
    running: false,
    mode: "Manual"
  };

  const speed = Number(data.speed || 0);
  const running = Boolean(data.running);

  const rpm = running ? (speed / 100) * baseRPM : 0;

  // =========================
  // EFFECTS
  // =========================
  useEffect(() => {
    const move = (e) => {
      if (!dragging) return;

      setPosition({
        x: e.clientX - offset.x,
        y: e.clientY - offset.y
      });
    };

    const stop = () => setDragging(false);

    window.addEventListener("mousemove", move);
    window.addEventListener("mouseup", stop);

    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseup", stop);
    };
  }, [dragging, offset]);

  if (!ctx || !tag) return null;

  // =========================
  // HANDLERS
  // =========================
  const handleMouseDown = (e) => {
    setDragging(true);
    setOffset({
      x: e.clientX - position.x,
      y: e.clientY - position.y
    });
  };

  // =========================
  // UI
  // =========================
  return (
    <div
      className="ac-faceplate"
      style={{
        position: "absolute",
        left: position.x,
        top: position.y,
        zIndex: 999
      }}
    >
      {/* HEADER */}
      <div className="ac-header" onMouseDown={handleMouseDown}>
        <span className="ac-title">{tag}</span>
        <button className="ac-close-btn" onClick={close}>✖</button>
      </div>

      {/* BODY */}
      <div className="ac-body">
        <div className="ac-row">
          <label>RPM</label>
          <input className="ac-input" value={rpm.toFixed(0)} readOnly />
        </div>

        <div className="ac-row">
          <label>SPEED %</label>
          <input
            className="ac-input"
            type="number"
            value={speed}
            onChange={(e) =>
              updateCooler(tag, { speed: Number(e.target.value) })
            }
          />
        </div>
      </div>

      {/* ACTIONS */}
      <div className="ac-actions">
        <button
            className={`ac-btn ac-start-btn ${running ? "active-start" : "inactive"}`}
            onClick={() => updateCooler(tag, { running: true })}
            >
            START
            </button>

            <button
            className={`ac-btn ac-stop-btn ${!running ? "active-stop" : "inactive"}`}
            onClick={() => updateCooler(tag, { running: false })}
            >
            STOP
            </button>
        <div className="ac-graph">
            <div className="ac-graph-inner">
                <img src={graphImg} alt="Air Cooler Graph" />

                {/* POINTER */}
                <div className="ac-graph-pointer" />
            </div>
            </div>
      </div>
      
    </div>
  );
}

export default AirCoolerFaceplate;